import React, { useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Grid, Button } from '@mui/material';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import DownloadIcon from '@mui/icons-material/Download';
import { useReactToPrint } from 'react-to-print';
import "../../assets/css/prints.css";
import Contractdetail from './Contractdetail';
import Contractsummary from './Contractsummary';
import "../commoncomponents/print.css";
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import reportslogo from "../../assets/images/reportslogo.png";
import moment from "moment";
import { Troubleshoot } from '@mui/icons-material';
const Contractdownloadform = forwardRef((props, ref) => {
  const { reportdata, onRenderComplete, setOpenModal, autoDownload, service, reportType, contractReport, level } = props;
  const printRef = useRef();
  const currentyear = new Date().getFullYear();
  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, "ENGA008");

  useEffect(() => {
    if (onRenderComplete) {
      onRenderComplete();
    }
  }, [onRenderComplete]);

  useEffect(() => {
    if (autoDownload && reportdata) {
      handleDownloadPDF();
      handleExcel();
    }
  }, [reportdata, autoDownload]);
  useEffect(() => {
    if (printRef.current) {
      printRef.current.style.width = '100%';
    }
  }, [reportdata]);


  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    onBeforePrint: () => {
      printRef.current.classList.add('printable-area'); // Apply printable-area class for print
    },
    onAfterPrint: () => {
      printRef.current.classList.remove('printable-area'); // Remove class after print
    },
  });



  console.log(level, "level")
  const getReportName = (contractReportValue) => {
    return contractReportValue === 1
      ? "Contract Out Register Detail Report"
      : contractReportValue === 2
        ? "Contract Out Register Summary Report"
        : "Contract Out Register Report";
  };

  const handleDownloadPDF = () => {
    const reportName = getReportName(contractReport.value);

    html2canvas(printRef.current, {
      scale: 2, // Higher scale for better quality
      useCORS: true,
    })
      .then((canvas) => {
        const pdf = new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: "a4", // A4 size
        });

        // PDF dimensions
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        // Canvas dimensions in mm
        const imgWidth = pdfWidth;
        const imgHeight = (canvas.height * pdfWidth) / canvas.width;

        // Track height and position
        let heightLeft = imgHeight;
        let pageHeight = pdfHeight - 10; // Account for top and bottom margins (10mm total)
        let position = 0;

        while (heightLeft > 0) {
          const canvasSection = document.createElement("canvas");
          const ctx = canvasSection.getContext("2d");

          // Set canvas section dimensions
          canvasSection.width = canvas.width;
          canvasSection.height = Math.min(canvas.height, pageHeight * (canvas.width / pdfWidth));

          // Copy the visible portion of the main canvas to the new canvas section
          ctx.drawImage(
            canvas,
            0,
            position * (canvas.width / pdfWidth),
            canvas.width,
            canvasSection.height,
            0,
            0,
            canvas.width,
            canvasSection.height
          );

          // Convert the section to an image
          const imgData = canvasSection.toDataURL("image/png");

          // Add the image to the PDF
          pdf.addImage(
            imgData,
            "PNG",
            0,
            5, // Start slightly below the top
            imgWidth,
            (canvasSection.height * pdfWidth) / canvas.width // Scale height proportionally
          );

          heightLeft -= pageHeight;
          position += pageHeight;

          // Add a new page if there's more content to display
          if (heightLeft > 0) {
            pdf.addPage();
          }
        }

        // Save the PDF
        pdf.save(`${reportName}.pdf`);
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };

  const handleExcel = async () => {
    const contractReportValue = contractReport.value;
    const reportName = getReportName(contractReportValue);

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(reportName);

    // Set dynamic column widths
    worksheet.columns = new Array(18).fill({ width: 20 });

    // Fetch and insert logo
    const rightLogoImage = await fetch(reportslogo).then(res => res.arrayBuffer());
    const rightLogoId = workbook.addImage({ buffer: rightLogoImage, extension: "png" });

    worksheet.addImage(rightLogoId, {
      tl: { col: 0.1, row: 0.1 },
      ext: { width: 80, height: 80 },
      editAs: "oneCell",
    });

    // Adding Title
    worksheet.mergeCells("A1:J5"); // Merge across the required range
    const titleCell = worksheet.getCell("A1"); // Set content in the first merged cell


    // Assign the title value
    titleCell.value = `${getReportName(contractReportValue)}\n` +
      `Hospital Master: ${level === 0 ? 'All' : level === 1 ? localStorage.getItem('FacilityName') : ''}\n` +
      `Service: ${service.label}\n` +
      `Year: ${currentyear}`;

    titleCell.font = { size: 15, bold: true };
    titleCell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };


    let headers = [];

    if (contractReport.value === 1) {
      let headers1 = [];
      let mergedCells = [];

      if (level === 1) {
        headers1 = [
          "No", "Company", "Status", "Asset Numbers", "Equipment / System Description", "Contract Number",
          "Contract Type", "Serial Number", "Model", "Start Date", "End Date",
          "Freq PPM / Year", "Period of Service Contract", "First Year", "Second Year", "Third Year",
          "Fourth Year", "Fifth Year", "Total PPM Rate Per Asset (RM)", "Total PPM Rate per Contract"
        ];

        mergedCells = [
          { range: "A6:A7", value: "No" },
          { range: "B6:B7", value: "Company" },
          { range: "C6:C7", value: "Status" },
          { range: "D6:D7", value: "Asset Numbers" },
          { range: "E6:E7", value: "Equipment / System Description" },
          { range: "F6:F7", value: "Contract Number" },
          { range: "G6:G7", value: "Contract Type" },
          { range: "H6:H7", value: "Serial Number" },
          { range: "I6:I7", value: "Model" },
          { range: "J6:J7", value: "Start Date" },
          { range: "K6:K7", value: "End Date" },
          { range: "L6:L7", value: "Freq PPM / Year" },
          { range: "M6:Q6", value: "PPM Rate / Asset (RM) Year" },
          { range: "M7:M7", value: "First Year" },
          { range: "N7:N7", value: "Second Year" },
          { range: "O7:O7", value: "Third Year" },
          { range: "P7:P7", value: "Fourth Year" },
          { range: "Q7:Q7", value: "Fifth Year" },
          { range: "R6:R7", value: "Total PPM Rate Per Asset (RM)" },
          { range: "S6:S7", value: "Total PPM Rate per Contract" }
        ];
      } else if (level === 0) {
        headers1 = [
          "No", "Hospital", "Company", "Status", "Asset Numbers", "Equipment / System Description", "Contract Number",
          "Contract Type", "Serial Number", "Model", "Start Date", "End Date",
          "Freq PPM / Year", "Period of Service Contract", "First Year", "Second Year", "Third Year",
          "Fourth Year", "Fifth Year", "Total PPM Rate Per Asset (RM)", "Total PPM Rate per Contract"
        ];

        mergedCells = [
          { range: "A6:A7", value: "No" },
          { range: "B6:B7", value: "Hospital" },
          { range: "C6:C7", value: "Company" },
          { range: "D6:D7", value: "Status" },
          { range: "E6:E7", value: "Asset Numbers" },
          { range: "F6:F7", value: "Equipment / System Description" },
          { range: "G6:G7", value: "Contract Number" },
          { range: "H6:H7", value: "Contract Type" },
          { range: "I6:I7", value: "Serial Number" },
          { range: "J6:J7", value: "Model" },
          { range: "K6:K7", value: "Start Date" },
          { range: "L6:L7", value: "End Date" },
          { range: "M6:M7", value: "Freq PPM / Year" },
          { range: "N6:R6", value: "PPM Rate / Asset (RM) Year" },
          { range: "N7:N7", value: "First Year" },
          { range: "O7:O7", value: "Second Year" },
          { range: "P7:P7", value: "Third Year" },
          { range: "Q7:Q7", value: "Fourth Year" },
          { range: "R7:R7", value: "Fifth Year" },
          { range: "S6:S7", value: "Total PPM Rate Per Asset (RM)" },
          { range: "T6:T7", value: "Total PPM Rate per Contract" }
        ];
      }

      // Apply merged cells
      mergedCells.forEach(({ range, value }) => {
        worksheet.mergeCells(range);
        let cell = worksheet.getCell(range.split(":")[0]);
        cell.value = value;
        cell.font = { bold: true };
        cell.alignment = { vertical: "middle", horizontal: "center" };
      });

      // Subheaders for Period of Service Contract
      const contractStartCell = level === 0 ? "K7" : "J7";
      const contractEndCell = level === 0 ? "L7" : "K7";

      worksheet.getCell(contractStartCell).value = "Contract Start Date";
      worksheet.getCell(contractEndCell).value = "Contract End Date";

      [contractStartCell, contractEndCell].forEach(cell => {
        worksheet.getCell(cell).font = { bold: true };
        worksheet.getCell(cell).alignment = { vertical: "middle", horizontal: "center" };
      });

      // Subheaders for PPM Rate Per Year
      const ppmYearHeaders = level === 0
        ? ["N7", "O7", "P7", "Q7", "R7"]
        : ["M7", "N7", "O7", "P7", "Q7"];

      ppmYearHeaders.forEach(cell => {
        worksheet.getCell(cell).font = { bold: true };
        worksheet.getCell(cell).alignment = { vertical: "middle", horizontal: "center" };
      });
    }


    const applyMergingAndFormatting = (worksheet, mergedCells) => {
      mergedCells.forEach(({ range, value }) => {
        worksheet.mergeCells(range);
        const cell = worksheet.getCell(range.split(":")[0]); // Get first cell in range
        cell.value = value;
        cell.font = { bold: true };
        cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
        cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
      });
    };

    const applyBordersToDataCells = (worksheet, startRow, totalColumns) => {
      const endRow = worksheet.lastRow ? worksheet.lastRow.number : startRow;
      for (let row = startRow; row <= endRow; row++) {
        for (let col = 1; col <= totalColumns; col++) {
          const cell = worksheet.getCell(row, col);
          cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
        }
      }
    };

    if (contractReport.value === 2) {
      if (level === 0) {
        headers = ["No", "Hospital", "Company", "Contract Number", "Contract Type", "Contract Duration (years)", "Total Contract Price", "Status"];

        const mergedCells = [
          { range: "A6:A7", value: "No" },
          { range: "B6:B7", value: "Hospital" },
          { range: "C6:C7", value: "Company" },
          { range: "D6:D7", value: "Contract Number" },
          { range: "E6:E7", value: "Contract Type" },
          { range: "F6:F7", value: "Contract Duration (years)" },
          { range: "G6:H6", value: "Period of Service Contract" },
          { range: "I6:I7", value: "Total Contract Price" },
          { range: "J6:J7", value: "Status" }
        ];

        applyMergingAndFormatting(worksheet, mergedCells);

        // Add Subheaders
        worksheet.getCell("G7").value = "Contract Start Date";
        worksheet.getCell("H7").value = "Contract End Date";

        ["G7", "H7"].forEach(cell => {
          worksheet.getCell(cell).font = { bold: true };
          worksheet.getCell(cell).alignment = { vertical: "middle", horizontal: "center" };
          worksheet.getCell(cell).border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
        });

        applyBordersToDataCells(worksheet, 8, headers.length);
      } else if (level === 1) {
        headers = ["No", "Company", "Contract Number", "Contract Type", "Contract Duration (years)", "Total Contract Price", "Status"];

        const mergedCells = [
          { range: "A6:A7", value: "No" },
          { range: "B6:B7", value: "Company" },
          { range: "C6:C7", value: "Contract Number" },
          { range: "D6:D7", value: "Contract Type" },
          { range: "E6:E7", value: "Contract Duration (years)" },
          { range: "F6:G6", value: "Period of Service Contract" },
          { range: "H6:H7", value: "Total Contract Price" },
          { range: "I6:I7", value: "Status" }
        ];

        applyMergingAndFormatting(worksheet, mergedCells);

        // Add Subheaders
        worksheet.getCell("F7").value = "Contract Start Date";
        worksheet.getCell("G7").value = "Contract End Date";

        ["F7", "G7"].forEach(cell => {
          worksheet.getCell(cell).font = { bold: true };
          worksheet.getCell(cell).alignment = { vertical: "middle", horizontal: "center" };
          worksheet.getCell(cell).border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
        });

        applyBordersToDataCells(worksheet, 8, headers.length);
      }
    }



    // Insert Data starting from Row 8
    let rowIndex = 8;
    let serialNumber = 1; // Move serialNumber outside to keep incrementing across all contracts

    if (reportdata?.length) {
      reportdata.forEach((contract, contractIndex) => {
        if (contractReport.value === 1) {
          contract.details.forEach((row, index) => {
            console.log("Row Index:", rowIndex, "Serial Number:", serialNumber); // Debugging

            let rowData = [];

            if (level === 1) {
              rowData = [
                serialNumber++, // Increment serialNumber correctly across all contracts
                row.companyName || '',
                row.status === 1 ? 'Active' : row.status === 2 ? 'Inactive' : 'Expired' || '',
                row.assetNo || '',
                row.equipment || '',
                row.contractNo || '',
                row.contractType || '',
                row.serialNo || '',
                row.model || '',
                row.startDate || '',
                row.endDate || '',
                row.frequency || '',
                row.firstyear || '',
                row.secondyear || '',
                row.thirdyear || '',
                row.fourthyear || '',
                row.fifthyear || '',
                row.totalPPMRateAsset || '',
                row.totalPPMRateContract || '',

              ];

            } else if (level === 0) {
              rowData = [
                serialNumber++,
                row.hospital || '', // Added hospital field
                row.companyName || '',
                row.status === 1 ? 'Active' : row.status === 2 ? 'Inactive' : 'Expired' || '',
                row.assetNo || '',
                row.equipment || '',
                row.contractNo || '',
                row.contractType || '',
                row.serialNo || '',
                row.model || '',
                row.startDate || '',
                row.endDate || '',
                row.frequency || '',
                row.firstyear || '',
                row.secondyear || '',
                row.thirdyear || '',
                row.fourthyear || '',
                row.fifthyear || '',
                row.totalPPMRateAsset || '',
                row.totalPPMRateContract || '',
              ];
            }

            if (rowData.length) {
              console.log("Row Data:", rowData); // Debugging

              const excelRow = worksheet.getRow(rowIndex);
              excelRow.values = rowData;

              // Apply right alignment to numeric columns
              [1, 10, 11, 12, 13, 14, 15, 16, 17, 18].forEach(colIndex => {
                excelRow.getCell(colIndex).alignment = { horizontal: "right" };
              });

              rowIndex++; // Move to the next row in Excel
            }
          });
        }


        else if (contractReport.value === 2) {
          if (level === 0) {
            const rowData = [
              contractIndex + 1, contract.hospital || '', contract.companyName || '', contract.contractNo || '',
              contract.contractType || '', contract.duration || '',
              contract.startDate || '',
              contract.endDate || '',
              contract.totalPPMRateContract || '', contract.status === 1 ? 'Active' : contract.status === 2 ? 'Inactive' : 'Expired'
            ];
            const excelRow = worksheet.getRow(rowIndex);
            excelRow.values = rowData;

            // Apply right alignment to numeric columns
            [1, 5, 6, 7, 8].forEach(colIndex => {
              excelRow.getCell(colIndex).alignment = { horizontal: "right" };
            });

            rowIndex++;
          } else if (level === 1) {
            const rowData = [
              contractIndex + 1 || '', contract.companyName || '', contract.contractNo || '',
              contract.contractType || '', contract.duration || '',
              contract.startDate || '',
              contract.endDate || '',
              contract.totalPPMRateContract || '', contract.status === 1 ? 'Active' : contract.status === 2 ? 'Inactive' : 'Expired'
            ];
            const excelRow = worksheet.getRow(rowIndex);
            excelRow.values = rowData;

            // Apply right alignment to numeric columns
            [1, 5, 6, 7, 8].forEach(colIndex => {
              excelRow.getCell(colIndex).alignment = { horizontal: "right" };
            });

            rowIndex++;
          }
        }

      });
    }



    worksheet.eachRow(row => {
      row.eachCell(cell => {
        cell.border = {
          top: { style: "thin", color: { argb: "000000" } },
          left: { style: "thin", color: { argb: "000000" } },
          bottom: { style: "thin", color: { argb: "000000" } },
          right: { style: "thin", color: { argb: "000000" } }
        };
      });
    });

    try {
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), `${getReportName(contractReportValue)}.xlsx`);

      console.log("File saved successfully");
    } catch (error) {
      console.error("Error while saving Excel file:", error);
    }
  };







  const handleClose = () => {
    setOpenModal(false);
  };

  useImperativeHandle(ref, () => ({
    handleDownloadPDF,
    handleExcel
  }));

  useEffect(() => {
  }, [contractReport, reportdata, service]);

  return (
    <>
      <Grid container justifyContent="flex-end" spacing={2} >
        {access?.canPrint && (<>
          <Grid item>
            <Button variant="contained" onClick={handlePrint}>Print</Button>
          </Grid>
          {/* <Grid item>
            <Button variant='contained'
              startIcon={<DownloadIcon />}
              style={{ marginRight: '8px' }} onClick={handleDownloadPDF}>PDF</Button>

          </Grid> */}
          <Grid item>
            <Button
              variant="contained"
              onClick={handleExcel}
              startIcon={<InsertDriveFileIcon />}
              style={{ marginRight: '8px' }}
            >
              XLSX
            </Button>

          </Grid>
        </>)}
        <Grid item>
          <Button variant="contained" onClick={handleClose}>Close</Button>
        </Grid>
      </Grid>



      <div ref={printRef} className="print-content" style={{ overflow: 'visible' }} >
        {contractReport?.value === 2 ? (
          <>

            <Contractsummary reportType={reportType} reportdata={reportdata} service={service} level={level} />
          </>
        ) : (
          <>

            <Contractdetail reportdata={reportdata} service={service} reportType={reportType} level={level} />
          </>
        )}
      </div>
    </>
  );
});

export default Contractdownloadform;
